import React from 'react'
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { certificateCount_ } from '../../../slices/reportSlice';
import { useModuleSettings } from '../../../components/moduleSettingsContext/ModuleSettingsContext';
import { useNavigate } from 'react-router-dom';
import { encrypt } from '../../../common/enc_dec';
import Loader from '../../../components/loader';
import DataTable from 'react-data-table-component';
import { Helmet } from 'react-helmet';
import userIcon from "../../../assets/avatar.png";

const CourseWiseCertificates = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { certificateCount } = useSelector((state) => state.report);
    const { search, setSearch, page, setPage, limit, setLimit, resetSettings } = useModuleSettings();

    useEffect(() => {
        dispatch(certificateCount_({
            search, page, limit
        }));
    }, [dispatch, search, page, limit]);

    const handleSearchChange = (event) => {
        const newSearch = event.target.value;
        setSearch(newSearch);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (newLimit) => {
        setLimit(newLimit);
    };

    const handleView = (row) => {
        resetSettings();
        navigate(`/certification-report/view?id=${encrypt(`${row.course_id}`)}`, { state: { id: row.course_id, total_certificates: row.total_certificates } });
    };

    const columns = [
        {
            name: "Sr No",
            selector: (row, index) => (page - 1) * limit + index + 1,
            sortable: false,
            minWidth: "80px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Course Id",
            selector: (row, index) => row.course_id,
            sortable: true,
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Image",
            selector: (row) =>
                row.user_course.image ? (
                    <img src={row.user_course.image} alt="trainer image" style={{ height: "6vh", padding: "5px" }} />
                ) : (
                    <img src={userIcon} alt="trainer image" style={{ height: "6vh", padding: "5px" }} />
                ),
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Name",
            selector: (row, index) => row.user_course.name,
            sortable: true,
            minWidth: "250px",
            maxWidth: "400px",
            class: "text-truncate",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Price",
            selector: (row) => row.user_course.price,
            cell: (row) => ('₹' + row.user_course.price),
            sortable: true,
            minWidth: "150px",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Certificates Issued",
            selector: (row, index) => row.total_certificates,
            sortable: true,
            minWidth: "250px",
            maxWidth: "400px",
            class: "text-truncate",
            style: {
                fontSize: "14px",
            },
        },
        {
            name: "Action",
            selector: (row) => (
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button className="btn" onClick={() => handleView(row)}>
                        <i
                            className="fe-eye font-22 avatar-title text-primary"
                            style={{ color: "blue" }}
                        />
                    </button>
                </div>
            ),
            minWidth: "250px",
            style: {
                fontSize: "14px",
                display: "flex",
                justifyContent: "center",
            },
        },
    ]

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
            },
        },
    };

    if (!certificateCount?.data) {
        return (
            <Loader />
        )
    }

    return (
        <>
            <Helmet>
                <title>GUARDING.TECH | Course</title>
            </Helmet>
            <div className='content-page'>
                <div className="col-md-12 col-xl-12 mt-3">
                    <div className={`widget-rounded-circle card`}>
                        <div className="card-body">
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <div>
                                    <h3 className="text-info">Purchased Course</h3>
                                </div>
                            </div>
                            <div className="row">
                                <DataTable
                                    title={null}
                                    columns={columns}
                                    data={certificateCount.data}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={certificateCount?.paging?.total}
                                    paginationDefaultPage={page}
                                    paginationPerPage={limit}
                                    paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
                                    onChangeRowsPerPage={handleRowsPerPageChange}
                                    onChangePage={handlePageChange}
                                    responsive
                                    selectableRowsHighlight
                                    highlightOnHover
                                    striped
                                    subHeader
                                    fixedHeader
                                    fixedFooter
                                    persistTableHead
                                    subHeaderWrap
                                    subHeaderAlign="left"
                                    noDataComponent={<h5 className="p-3">No Data Found</h5>}
                                    subHeaderComponent={
                                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <div>
                                                    <input
                                                        type="text"
                                                        value={search}
                                                        onChange={handleSearchChange}
                                                        placeholder="Search"
                                                        style={{ padding: "4px", borderRadius: "5px", border: "1px solid #ccc" }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CourseWiseCertificates;